/* quick-add.js — <sf-quick-add-panel>: the injected quick-add content (sections/quick-add.liquid).
   product-form.js owns the variant picker and the add-to-bag request; this element only closes the quick-add
   drawer once the line has been added (toast mode) or hands over to the cart drawer (drawer mode). */
'use strict';
(function () {
  const theme = window.theme || (window.theme = {});
  class SFQuickAddPanel extends HTMLElement {
    connectedCallback() {
      this._unsub = theme.pubsub ? theme.pubsub.subscribe('cart:updated', (payload) => this.onAdded(payload)) : null;
      this.addEventListener('submit', () => { this._submitted = Date.now(); }, true);
    }
    disconnectedCallback() { if (this._unsub) this._unsub(); }
    onAdded(payload) {
      /* Only react to the add that came from this panel (a submit within the last 10s). */
      if (!this._submitted || Date.now() - this._submitted > 10000) return;
      if (payload && payload.source && payload.source !== 'add') return;
      this._submitted = 0;
      const drawer = this.closest('sf-drawer');
      if (drawer && typeof drawer.close === 'function') setTimeout(() => drawer.close(), 200);
    }
  }
  if (!customElements.get('sf-quick-add-panel')) customElements.define('sf-quick-add-panel', SFQuickAddPanel);
})();
